<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.68967 1.96552L10.1724 1L10.6552 1.96552L11.6207 2.44828L10.6552 2.93104L10.1724 3.89655L9.68967 2.93104L8.72415 2.44828L9.68967 1.96552Z"
      fill="#B0D1CB"
    />
    <path
      d="M3.41379 4.3793L4.62069 1.9655L5.82759 4.3793L8.24138 5.5862L5.82759 6.79309L4.62069 9.20689L3.41379 6.79309L1 5.5862L3.41379 4.3793Z"
      fill="#6A8681"
    />
    <path
      d="M11.1379 8.24137L12.1034 6.31034L13.069 8.24137L15 9.20689L13.069 10.1724L12.1034 12.1034L11.1379 10.1724L9.2069 9.20689L11.1379 8.24137Z"
      fill="#8CA7A2"
    />
    <path
      d="M6.06895 12.1034L6.79309 10.6552L7.51722 12.1034L8.9655 12.8276L7.51722 13.5517L6.79309 15L6.06895 13.5517L4.62067 12.8276L6.06895 12.1034Z"
      fill="#B0D1CB"
    />
    <path
      d="M2.86667 9.86667L3.1 9.4L3.33333 9.86667L3.8 10.1L3.33333 10.3333L3.1 10.8L2.86667 10.3333L2.4 10.1L2.86667 9.86667Z"
      fill="#B0D1CB"
    />
  </svg>
</template>
